import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";

export const leaderFoundationalInfoAPI = createApi({
  reducerPath: "leaderFoundationalInfoAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["FoundationalInfo"],
  endpoints: (builder) => ({
    getFoundationalInfoData: builder.query<any, foundationalInfoArgsType>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/background`,
        method: "GET",
      }),
      providesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: "FoundationalInfo", id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
    createFoundationalInfo: builder.mutation<any, foundationalInfoArgsType>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/background`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: "FoundationalInfo", id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
  }),
});

export const {
  useGetFoundationalInfoDataQuery,
  useCreateFoundationalInfoMutation,
} = leaderFoundationalInfoAPI;
